import styled from 'styled-components/macro';
const MobileView = styled.div `
  @media ${props => props.breakpoint || props.theme.device.tablet} {
    display: none;
  }
`;
export default MobileView;
